'use client'

import type { AccordionProps } from '@pearlconvert/ui/components/accordion/accordion.types'

import classNames from 'classnames'
import React from 'react'

import { AccordionContext } from '@pearlconvert/ui/components/accordion/accordion.context'
import { useAccordion } from '@pearlconvert/ui/components/accordion/batons/use-accordion'

import '@pearlconvert/ui/components/accordion/styles/accordion.scss'

export default function Accordion({
  children,
  className: customClassName,
  canOpenMultiple,
  onToggle,
  animationDelay,
  initialActiveIds,
}: Readonly<AccordionProps>) {
  const { activeIds, isInitial, handleChangeActive } = useAccordion({
    canOpenMultiple,
    onToggle,
    initialActiveIds,
  })

  return (
    <AccordionContext
      animationDelay={animationDelay}
      changeActive={handleChangeActive}
      activeIds={activeIds}
      isInitial={isInitial}
    >
      <ul className={classNames('accordion', customClassName)}>{children}</ul>
    </AccordionContext>
  )
}
